import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import { WebServices } from "../shared/models/enum/web-services.enum";
import { takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';

// import { ObsicashStoreService } from './obsicash/obsicash-store.service';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class UserService {
  baseUrl: any = environment.apiUrl + 'user/';
  isLoggedIn: any = false;
  loggedData: any = false;
  isChange = false;
  isRefresh = false;
  isLogout = false;
  isLogin: any = false;
  isVerification = false;
  isUserOnline: any = {};
  isResetTimer: any = false;
  isStartTimer: any = false;
  isResolvedTrade: any = false;
  isReadNotification: any = false;
  notificationList: any = [];
  tradeId: any = '';
  userRegistrationEmil: any = '';
  showVerifyUserToast: any = new Subject<string>();
  // tslint:disable-next-line: no-output-native
  @Output() changeData: EventEmitter<boolean> = new EventEmitter();
  @Output() refreshTokenEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() logoutEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() loginEventObj: EventEmitter<boolean> = new EventEmitter();
  @Output() verificationEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() getAllWebsiteReputation: EventEmitter<boolean> = new EventEmitter();
  @Output() getAllNotification: EventEmitter<boolean> = new EventEmitter();

  @Output() userOnlineEvent: EventEmitter<any> = new EventEmitter();
  @Output() resetTimerEvent: EventEmitter<any> = new EventEmitter();
  @Output() startTimerEvent: EventEmitter<any> = new EventEmitter();
  @Output() changeLanguageEvent: EventEmitter<string> = new EventEmitter();
  @Output() changeLanguageEvent2: EventEmitter<string> = new EventEmitter();
  @Output() tradeResolvedEvent: EventEmitter<string> = new EventEmitter();
  @Output() tradeUpdateEvent: EventEmitter<string> = new EventEmitter();
  @Output() unreadNotificationEvent: EventEmitter<string> = new EventEmitter();
  @Output() updateReadNotificationEvent: EventEmitter<string> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private activeRouter: ActivatedRoute,
    // public obsicashStore: ObsicashStoreService
  ) {
    const tokendata = this.getToken();
    if (tokendata.token) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
    let parameters = new URLSearchParams(window.location.search);
    this.activeRouter.queryParams.subscribe((a) => {
      // if (!environment.production)
      // console.log(a, parameters, this.getParameterByName('token'), window.location.href)
      let token = a.token || this.getParameterByName('token') || parameters.get('token');
      if (token) {
        this.setUserData({});
        this.setToken(token)
        this.getProfileData(token).toPromise().then((a: any) => {
          if (a.status === 200) {
            let tokenData = { token: token, createdAt: new Date() }
            let data = { ...a.data, ...tokenData };
            this.setUserData(data, true);
            this.startTokenTime();
            this.isLoggedIn = true;
            this.changeUserData();
          }
        })
      }
    })
    // console.log(this.isLoggedIn)
  }

  getParameterByName(name, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  registrationEmail(email: string) {
    this.userRegistrationEmil = email;
  }

  loginEvent() {
    // console.log('Login Event');
    this.isLogin = !this.isLogin;
    this.loginEventObj.emit(this.isLogin);
  }

  updateTrade(actionId) {
    this.tradeId = actionId;
    this.tradeUpdateEvent.emit(this.tradeId);
  }

  readNotification() {
    this.isReadNotification = !this.isReadNotification;
    this.updateReadNotificationEvent.emit(this.isReadNotification);
  }

  tradeResolved() {
    this.isResolvedTrade = !this.isResolvedTrade;
    this.tradeResolvedEvent.emit(this.isResolvedTrade);
  }

  unreadNotifications(list) {
    this.notificationList = list;
    this.unreadNotificationEvent.emit(this.notificationList);
  }

  startTokenTime() {
    this.isStartTimer = !this.isStartTimer;
    this.startTimerEvent.emit(this.isStartTimer);
  }

  resetTokenTime() {
    this.isResetTimer = !this.isResetTimer;
    this.resetTimerEvent.emit(this.isResetTimer);
  }

  userOnline(data) {
    this.isUserOnline = data;
    this.userOnlineEvent.emit(this.isUserOnline);
  }

  websiteReputation() {
    this.getAllWebsiteReputation.emit()
  }

  updateNotification() {
    this.getAllNotification.emit()
  }

  changeToken() {
    this.isRefresh = !this.isRefresh;
    this.refreshTokenEvent.emit(this.isRefresh);
  }

  changeUserData(orderId: any = '') {
    this.isChange = !this.isChange;
    this.changeData.emit(orderId);
  }

  changeVerificationStatusLanguage() {
    this.isVerification = !this.isVerification;
    this.verificationEvent.emit(this.isVerification);
  }

  logOutEventHit() {
    this.isLogout = !this.isLogout;
    this.logoutEvent.emit(this.isLogout);
  }

  isFirstClick(sectionName) {
    const userData = this.loggedData = this.getLoggedData();
    if (sectionName === 'DASHBOARD') {
      return !userData.dashboardClicked;
    } else if (sectionName === 'BUYSELL') {
      return !userData.buySellClicked;
    } else if (sectionName === 'EXCHANGE') {
      return !userData.exchangeClicked;
    } else if (sectionName === 'WALLET') {
      return !userData.walletClicked;
    } else if (sectionName === 'OBSIDIAM_PAY') {
      return !userData.obsidiamPayClicked;
    }
  }

  changeVerificationStatusString(statusString, emit) {
    const loggedData = this.getLoggedData();
    loggedData.verificationStatusString = statusString;
    if (statusString === 'SUCCESS') {
      loggedData.verificationStatus = true;
    }
    this.setUserData(loggedData);
    if (emit) {
      this.changeVerificationStatusLanguage();
    }
  }

  changeFisFirstClickValue(sectionName) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    if (sectionName === 'DASHBOARD') {
      loggedData.dashboardClicked = true;
    } else if (sectionName === 'BUYSELL') {
      loggedData.buySellClicked = true;
    } else if (sectionName === 'EXCHANGE') {
      loggedData.exchangeClicked = true;
    } else if (sectionName === 'WALLET') {
      loggedData.walletClicked = true;
    } else if (sectionName === 'OBSIDIAM_PAY') {
      loggedData.obsidiamPayClicked = true;
    }
    this.setUserData(loggedData);
    return this.http.get(this.baseUrl + 'update-click-status?section=' + sectionName, { headers });
  }

  checkUsername(username) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'check-username-exist', { username }, { headers });
  }

  checkForUserVerified(returnValue) {
    // returnValue trur param used for return the status that user is verified or not
    // returnValue false param doesn't return anything just show the popup
    const loggedData = this.getLoggedData();
    // console.log('loggedData==', loggedData)
    if (
      loggedData &&
      loggedData.verificationStatusString &&
      loggedData.verificationStatusString != "SUCCESS"
    ) {
      // this.userService.showVerifyUserToast.next('show');
      if (returnValue) {
        return false
      }

      // this.showVerifyUserToast.next('show');
      setTimeout(() => {
        this.showVerifyUserToast.next('show');
      }, 500);
    } else if (
      loggedData &&
      loggedData.verificationStatusString &&
      loggedData.verificationStatusString === "SUCCESS"
    ) {
      if (returnValue) {
        return true
      }
    } else {
      if (returnValue) {
        return false
      }
    }
  }

  checkUsernameExistQuickTransfer(username, data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + data.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'check-user-exist-quick-transfer', { username }, { headers });
  }

  getReferralStatus() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.get(this.baseUrl + 'get-referral-status', { headers });
  }

  getReferralEarning() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-referral-earning', { headers });
  }

  checkEmail(email) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'check-email-exist', { email }, { headers });
  }

  checkPhone(phone, countryCodeNumeric) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'check-phone-exist', { phoneNumber: phone, countryCodeNumeric }, { headers });
  }

  checkReferralCode(code) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'validate-referral-code?referralCode=' + code, { headers });
  }

  subscribeWithdrawFeeNotification(asset) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'subscribe-withdraw-fee-notification?asset=' + asset, { headers });
  }

  subscribe(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'subscribe', data, { headers });
  }

  resendConfirmation(email) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'resend-verification-email', { email }, { headers });
  }

  login(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'login', data, { headers });
  }

  verifyPassword(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'validate-password', data, { headers });
  }

  deleteUserData() {
    localStorage.removeItem(environment.authName)
    this.cookieService.delete(environment.authName, '/')
  }

  setUserData(data, isToken = false) {
    return new Promise((resolve, reject) => {
      if (data.email) {
        let date = null, minute = 15;
        if (minute) {
          date = new Date();
          date.setTime(date.getTime() + (minute * 60 * 60 * 1000));
        }
        const now = new Date();
        now.setHours(now.getHours() + 8);
        localStorage.setItem(environment.authName, JSON.stringify(data));
        this.cookieService.set(environment.authName, JSON.stringify(data), now, '/', window.location.hostname, true, 'Strict');
        resolve(true);
      } else {
        resolve(true);
      }
    });
  }

  setToken(token) {
    let data = {
      token: token,
      createdAt: new Date()
    }
    const now = new Date();
    now.setHours(now.getHours() + 8);
    localStorage.setItem('access-token', JSON.stringify(data));
    // console.log('window.location.hostname', window.location.hostname)
    this.cookieService.set('access-token', JSON.stringify(data), now, '/', window.location.hostname, true, 'Strict');
  }

  getToken() {
    let data: any = this.cookieService.get('access-token');
    data = data ? JSON.parse(data) : null;
    let data2: any = localStorage.getItem('access-token');
    data2 = data2 ? JSON.parse(data2) : null;
    return data ? data : data2 ? data2 : {};
  }

  deleteToken() {
    localStorage.removeItem('access-token')
    this.cookieService.delete('access-token', '/');
  }

  getLoggedData() {
    const data: any = this.cookieService.get(environment.authName);
    const lng = this.cookieService.get('OBSIDIAM-LOCALE') || 'en';
    let data2: any = localStorage.getItem(environment.authName);
    data2 = data2 ? JSON.parse(data2) : null;
    try {
      return data ? {
        ...JSON.parse(data), ...{ locale: lng }
      } : data2 ? {
        ...data2, ...{ locale: lng }
      } : { locale: lng };
    } catch (e) {
      this.cookieService.delete(environment.authName);
      return {};
    }
  }

  setBanxaData(data) {
    localStorage.setItem('banxa-order', JSON.stringify(data));
  }

  getBanxaData() {
    return JSON.parse(localStorage.getItem('banxa-order'));
  }

  deleteBanxaData() {
    localStorage.removeItem('banxa-order');
  }

  verifyEmail(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'verify-email', data, { headers });
  }

  sendSMSVerification(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'send-sms-verification', data, { headers });
  }

  updateNumber(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'verify-sms-change-number-user', data, { headers });
  }

  verifySMSCode(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'verify-sms-code', data, { headers });
  }

  getTeam() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.get(environment.apiUrl + 'static-content/get-team', { headers });
  }

  getStaticContent(type) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.get(environment.apiUrl + 'static-content/get-content?type=' + type, { headers });
  }

  getAnnouncements(lang, p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.get(environment.apiUrl + 'static-content/get-announcements?language=' + lang + '&pageNo=' + p + '&size=' + ps, { headers });
  }

  forgotPassword(data, lang) {
    const loggedData = this.getLoggedData();
    // console.log("loggedData.preferredLanguage", loggedData.preferredLanguage);
    // console.log("loggedData.locale", loggedData.locale);

    const headers = new HttpHeaders().set('Accept-Language', lang || loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'forgot-password', data, { headers });
  }

  resetPassword(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'change-forgotten-password', data, { headers });
  }

  verifyAuthyLogin(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'verify-authy-login', data, { headers });
  }

  addIp(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'add-ip', data, { headers });
  }

  getVerificationUrl(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-verification-url', { headers });
  }

  postVerificationUrl(req) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(environment.apiObsicashUrl + environment.jweUrls.URL_POST_OBSICASH_JUMIO_REGISTER.url, req, { headers });
  }

  refreshToken(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'refresh-token', { headers });
  }

  generateDashTextAddress() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'dash-text-address', { headers });
  }

  generateDashTextAddressWithPhone(phone) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'dash-text-address?phone=' + phone, { headers });
  }

  getProfileData(token) {

    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    token = tokenData.token || token;
    // console.log(token)
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);

    return this.http.get(this.baseUrl + 'get-user-details', { headers });
  }

  logout(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'user-logout', data, { headers });
  }

  getReferralCode(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-referral-code', { headers });
  }

  updatePassword(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-password', data, { headers });
  }

  disableAccount(userId, authyCode, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'disable-account', {
      status: true,
      userId,
      verificationCode: authyCode
    }, { headers });
  }

  getLoginActivities(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-login-activities?pageNo=' + data.pageNo + '&size=' + data.size, { headers });
  }

  getAuthorizedIps(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-authorized-ips?pageNo=' + data.pageNo + '&size=' + data.size, { headers });
  }

  startAntiPhising(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'start-anti-phishing', data, { headers });
  }

  updateAntiPhising(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-phishing-code', data, { headers });
  }

  updateAntiPhisingStatus(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-phishing-status', data, { headers });
  }

  updateIpManagement(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-ip-management', data, { headers });
  }

  updateAuthyStatus(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-authy-status', data, { headers });
  }

  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  deleteAcivity(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'delete-authorized-ip', data, { headers });
  }

  updateCurrency(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-preferred-currency', data, { headers });
  }

  updateDocumentStatus(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-document-status', data, { headers });
  }

  updateEmail(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-email', data, { headers });
  }

  sendUpdateEmail(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'send-update-email', data, { headers });
  }

  sendEmailCodeForPhoneUpdate() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'send-phone-update-verification-email', { headers });
  }

  updateLanguage(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-language', data, { headers });
  }

  changeLanguageEmit(lang, emit) {
    const loggedData = this.getLoggedData();
    loggedData.preferredLanguage = lang;
    this.setUserData(loggedData);
    if (!environment.production)
      console.log('emit', emit)
    if (emit) {
      this.changeLanguageEvent.emit(lang);
    } else {
      this.changeLanguageEvent2.emit(lang);
    }
  }

  getVerificationStatus(userId, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-verification-status', { headers });
  }

  getVerificationStatusBusiness() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-business-verification-info', { headers });
  }

  getPerson(search) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'business-find-user/' + search, { headers });
  }

  getInvitationList(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-invitation-list', { headers });
  }

  sendInvitation(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'send-invitation', data, { headers });
  }

  getDashboardDetail(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-dashboard-details', { headers });
  }

  getDashboardProfits(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'calculate-profit', { headers });
  }

  getRecentTransection(data, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'get-recent-transactions', data, { headers });
  }

  getUnreadNotifications(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-unseen-notifications', { headers });
  }

  updateNotificationSeen(id, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-notification-seen-status', { id: id }, { headers });
  }

  updateAllNotificationSeen(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'read-all-notifications', { headers });
  }

  getAllNotifications(page, pageSize, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-all-notifications?pageNo=' + page + '&size=' + pageSize, { headers });
  }

  getBuySellStatus() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-buy-sell-status', { headers });
  }

  updatePhone(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'update-phone', data, { headers });
  }

  updatePhoneFL(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'update-phone-first-login', data, { headers });
  }

  updateWrongEmail(emails) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'update-wrong-email', {
      wrongEmail: emails.wrongEmail,
      newEmail: emails.newEmail
    }, { headers });
  }

  getUserOnlineStatus(username) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-online-status?username=' + username, { headers });
  }

  getFirstName(username) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'get-first-name', { username }, { headers });
  }

  geetestRegister() {
    const tokenData = this.getToken();
    let ct = new Date().getTime();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json');
    return this.http.get(this.baseUrl + 'gt/register?t=' + ct);
  }

  getTermsAcceptedStatus() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-terms-accepted-status', { headers });
  }

  resetProfit() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'reset-profit', { headers });
  }

  updateTermsAcceptedStatus(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-terms-accepted-status', data, { headers });
  }

  getProfit(coinShortName, interval, token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-historical-balance?coinShortName=' + coinShortName + '&interval=' + interval, { headers });
  }

  calculateProfit(token) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'calculate-profit', { headers });
  }

  getCountry() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-country', { headers });
  }

  getCountryBusiness() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-countries-business', { headers });
  }

  clearNotification(notificationType) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'clear-notification?notificationType=' + notificationType, { headers });
  }

  disableSucessPopup() {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'disable-success-prompt', { headers });
  }

  updateHeardFrom(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-heard-from', {
      heardFrom: data.heardFrom,
      otherHeardFrom: data.otherHeardFrom
    }, { headers });
  }

  isEnabledModule(module) {
    let userData = this.getLoggedData();
    let visible = false;
    if (userData && userData.modules) {
      userData.modules.forEach(modules => {
        if (modules.module === module) {
          visible = true;
        }
      });
    }
    return visible;
  }


  // BUSINESS

  subscribeBusiness(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Accept-Language', loggedData.preferredLanguage || loggedData.locale).set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + 'subscribe-business', data, { headers });
  }
  onboardingStepPerson(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.put(this.baseUrl + 'business-onboarding/PERSONS', data, { headers });
  }
  onboardingStepKYC(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.put(this.baseUrl + 'business-onboarding/KYC', data, { headers });
  }
  onboardingStepDocuments(data) {
    const loggedData = this.getLoggedData();
    const tokenData = this.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.put(this.baseUrl + 'business-onboarding/DOCUMENTS', data, { headers });
  }

}
